import React from 'react';

import { Typography } from '@mui/material';



export default function FightDog(props) {

    let breed = props.breed



    if (breed.prohibited === undefined) {
        return (
            <>
                <Typography variant="h2" gutterBottom>
                    {breed.breed} in Deutschland erlaubt?
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Die Rasse {breed.name} wird nicht als Listenhund eingestuft und seine Haltung ist in jedem Bundesland <b>ohne Einschränkungen möglich</b>.
                </Typography>
            </>
        )
    }



    if (breed.prohibited) {
        return (
            <>
                <Typography variant="h2" gutterBottom>
                    {breed.breed} in Deutschland erlaubt?
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Die Rasse "{breed.breed}" wird in manchen Bundesländern in Deutschland als Listenhund eingestuft. 
                    Das heißt, dass du für die Haltung eines solchen Hundes volljährig sein und ein Führungszeugnis vorlegen musst.
                    Für das Halten von Kampfhunden brauchst du den <b>Nachweis einer bestandenen Sachkundeprüfung und des Hundeführerscheins</b>.
                    Ein {breed.breed} muss unter Umständen einen Verhalts- oder Wesentest durchlaufen.
                </Typography>

            </>
        )
    }
    

}
